import { BrowserRouter as Router, Navigate} from 'react-router-dom';
import { Route, Routes } from 'react-router';

import LoginPage from "./pages/LoginPage/LoginPage";
import PasswordRecoveryRequestPage from "./pages/PasswordRecoveryRequestPage/PasswordRecoveryRequestPage";
import PasswordRecoveryConfirmPage from "./pages/PasswordRecoveryConfirmPage/PasswordRecoveryConfirmPage";
import CampaignsPage from "./pages/CampaignsPage/CampaignsPage";
import CampaignDetailsPage from "./pages/CampaignDetailsPage/CampaignDetailsPage";
import StatisticsPage from "./pages/StatisticsPage/StatisticsPage";
import SettingsPage from "./pages/SettingsPage/SettingsPage";
import LogoutPage from "./pages/LogoutPage/LogoutPage";

import "./App.scss";

const App = () => {
  return (
    <Router basename="/affiliate">
      <Routes>
        <Route path='/login' element={<LoginPage />} />
        <Route path='/password-recovery' element={<PasswordRecoveryRequestPage />} />
        <Route path='/password-recovery/:recoverKey' element={<PasswordRecoveryConfirmPage />}/>
        <Route path='/campaigns' element={<CampaignsPage />} />
        <Route path='/campaigns/:hash' element={<CampaignDetailsPage />} />
        <Route path='/statistics' element={<StatisticsPage />} />
        <Route path='/settings' element={<SettingsPage />} />
        <Route path='/logout' element={<LogoutPage />} />
        <Route path='*' element={<Navigate to="/login" replace={true}/>}/>
      </Routes>
    </Router>
  );
};

export default App;
